import { writable, get } from "svelte/store";
import { getPreciseDistance } from "geolib";
import profile from "./profile.js";
import persisted from "./common/persisted.js";
import locality from "./locality.js";
import chronology from "./chronology.js";
import journey, { journeySubscribeThrottled } from "./journey.js";

const MINIMUM_UPDATE_INTERVAL = 5000;

function createMetricsStore() {
    const { subscribe, set, update } = writable({
        distance: 0,
        duration: 0,
        emissions: 0,
        states: []
    });

    let lastJourneyUpdateAt = 0;
    let previousLocation;

    journeySubscribeThrottled(MINIMUM_UPDATE_INTERVAL, (journey) => {
        if (Date.now() - lastJourneyUpdateAt < MINIMUM_UPDATE_INTERVAL) {
            return;
        }

        lastJourneyUpdateAt = Date.now();

        update((state) => {
            if (!journey.location) {
                return state;
            }

            let distance = state.distance;

            if (previousLocation) {
                distance += getPreciseDistance(
                    previousLocation,
                    journey.location
                );
            }

            previousLocation = journey.location;

            const selectedProfile = get(profile);

            return {
                ...state,
                distance,
                emissions:
                    distance *
                    (selectedProfile ? selectedProfile.vehicle.emissions : 0.0)
            };
        });
    });

    let lastChronologyUpdateAt = 0;

    chronology.subscribe((chronology) => {
        if (Date.now() - lastChronologyUpdateAt < MINIMUM_UPDATE_INTERVAL) {
            return;
        }

        lastChronologyUpdateAt = Date.now();

        update((state) => ({ ...state, duration: chronology.totalDuration }));
    });

    locality.subscribe((locality) => {
        if (!locality) {
            return;
        }

        const stateName = locality.split(", ").at(-1);

        if (stateName) {
            update((state) => ({
                ...state,
                states: Array.from(
                    new Set(
                        [...state.states, stateName].filter(
                            (state) => !/\d/.test(state)
                        )
                    )
                )
            }));
        }
    });

    return {
        subscribe,
        set
    };
}

const metrics = persisted("metrics:v4", true, createMetricsStore());

export default metrics;
